import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=0469db3c&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Delete.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Delete.vue
// module id = 2214
// module chunks = 1